export const SWEEPSTAKES_SET_PRIZE_ID = "SWEEPSTAKES_SET_PRIZE_ID";
export const SWEEPSTAKES_SET_SUBMISSION_RESULT = "SWEEPSTAKES_SET_SUBMISSION_RESULT";
export const SWEEPSTAKES_RESET_SUBMISSION_RESULT = "SWEEPSTAKES_RESET_SUBMISSION_RESULT";
export const SWEEPSTAKES_SET_SUBMISSION_STATUS = "SWEEPSTAKES_SET_SUBMISSION_STATUS";
export const SWEEPSTAKES_RESET_SUBMISSION_STATUS = "SWEEPSTAKES_RESET_SUBMISSION_STATUS";
export const SWEEPSTATES_SET_LAST_SUBMISSION = "SWEEPSTATES_SET_LAST_SUBMISSION";

export const setPrizeId = data => ({
  type: SWEEPSTAKES_SET_PRIZE_ID,
  data
});

export const setSubmissionResult = data => ({
  type: SWEEPSTAKES_SET_SUBMISSION_RESULT,
  data
});

export const resetSubmissionResult = data => ({
  type: SWEEPSTAKES_RESET_SUBMISSION_RESULT,
  data
});

export const setSubmissionStatus = data => ({
  type: SWEEPSTAKES_SET_SUBMISSION_STATUS,
  data
});

export const resetSubmissionStatus = data => ({
  type: SWEEPSTAKES_RESET_SUBMISSION_STATUS,
  data
});

export const setLastSubmission = data => ({
  type: SWEEPSTATES_SET_LAST_SUBMISSION,
  data
});


// WEBPACK FOOTER //
// ./src/js/instantwinform/actions/sweepstakes.js